var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { getRebornUrl } from '@/shared/utils/helpers';
import { createSearch } from '@/clients/search';
import { connect } from '@/overmind';
let CompanyDetailIframeModal = class CompanyDetailIframeModal extends Vue {
    constructor() {
        super(...arguments);
        this.retryTimers = [];
    }
    get iframeSrc() {
        const params = new URLSearchParams({ cnpj: this.cnpj });
        // Usa o prop; se ausente, lê diretamente do param da rota atual
        const infosetId = this.infosetId ||
            (this.$route && this.$route.params && this.$route.params.infosetId) ||
            null;
        if (infosetId)
            params.set('infosetId', infosetId);
        return `${getRebornUrl()}/company?${params.toString()}`;
    }
    get panelWidth() {
        if (typeof window === 'undefined')
            return 900;
        // Deixa a barra lateral esquerda (~390px) visível
        return Math.max(window.innerWidth - 390, 600);
    }
    onLoad() {
        this.clearRetryTimers();
        this.sendInit();
        // Retentativas cobrem a corrida entre o @load e o React montar o listener —
        // mesmo esquema do handshake da busca (SearchReborn).
        this.retryTimers.push(setTimeout(() => this.sendInit(), 500));
        this.retryTimers.push(setTimeout(() => this.sendInit(), 2000));
    }
    sendInit() {
        const iframe = this.$refs.iframe;
        if (!iframe || !iframe.contentWindow)
            return;
        // @ts-ignore TS2349: $auth injetado pelo vue-auth
        const user = this.$auth.user() || {};
        const payload = {
            type: 'COMPANY_INIT',
            cnpj: this.cnpj,
            token: localStorage.getItem('auth_token_default') || '',
            // Feature flags da conta: ligam o WhatsApp do decisor e a validação de
            // e-mails no detalhe da empresa do reborn.
            features: Array.isArray(user.features) ? user.features : [],
        };
        // Usa o prop; se ausente, lê diretamente do param da rota atual
        const infosetId = this.infosetId ||
            (this.$route && this.$route.params && this.$route.params.infosetId) ||
            null;
        if (infosetId)
            payload['infosetId'] = infosetId;
        // Sem log do payload: ele carrega o token de autenticação.
        iframe.contentWindow.postMessage(payload, '*');
    }
    handleMessage(event) {
        if (!event.data)
            return;
        const tipo = event.data.type;
        if (tipo === 'IFRAME_READY') {
            this.clearRetryTimers();
            this.sendInit();
        }
        if (tipo === 'CLOSE_COMPANY_DETAIL') {
            this.close();
        }
        // Lupa "Buscar empresas neste CNAE" na aba Registro do iframe React.
        // O React já confirmou com o usuário que a busca atual será reiniciada,
        // então aqui é só executar: fecha o painel e navega a guia atual.
        if (tipo === 'SEARCH_BY_CNAE') {
            this.searchByCnae(event.data.cnae);
        }
        // Compatibilidade: builds antigos do atlas-reborn ainda pedem a aba nova.
        if (tipo === 'SEARCH_BY_CNAE_NEW_TAB') {
            this.searchByCnae(event.data.cnae, true);
        }
        // Salvar a busca corrente antes de trocá-la pela busca por CNAE. Quem tem
        // o searchId e os totais é o shell — o iframe só conhece o CNPJ aberto.
        if (tipo === 'SAVE_CURRENT_SEARCH') {
            this.saveCurrentSearch(event.data.requestId, event.data.name);
        }
    }
    async searchByCnae(cnae, newTab = false) {
        if (!cnae)
            return;
        try {
            const params = {
                search: {
                    match: { cnae1: [cnae] },
                    offset: 0,
                    return_size: 10,
                    aggregation_type: 'advanced',
                },
            };
            const response = await createSearch(params);
            const searchId = response.data.search_id;
            if (newTab) {
                window.open(`${window.location.origin}/search/${searchId}`, '_blank');
                return;
            }
            // Fecha o painel antes de navegar: ele fica por cima da rota e
            // continuaria aberto sobre a busca nova.
            this.close();
            this.$router
                .push({ name: 'searchId', params: { searchId } })
                .catch(() => {
                // NavigationDuplicated (mesma busca) não é erro para o usuário.
            });
        }
        catch (e) {
            console.log('[CompanyDetailIframeModal] searchByCnae falhou', e);
        }
    }
    /**
     * Salva a busca aberta agora e devolve o resultado ao iframe. O eco com o
     * mesmo requestId é obrigatório: sem ele o React não tem como dizer se
     * salvou, e o usuário confirmaria a troca achando que guardou a anterior.
     */
    async saveCurrentSearch(requestId, name) {
        const reply = (ok, error) => {
            const iframe = this.$refs.iframe;
            if (!iframe || !iframe.contentWindow)
                return;
            iframe.contentWindow.postMessage({ type: 'SAVE_CURRENT_SEARCH_RESULT', requestId, ok, error }, '*');
        };
        const self = this;
        const searchId = self.currentSearchId;
        if (!searchId) {
            // Detalhe aberto fora de uma busca (ex.: a partir de um infoset).
            reply(false, 'Não há uma busca ativa para salvar.');
            return;
        }
        if (!name || !name.trim()) {
            reply(false, 'Digite um nome para a busca.');
            return;
        }
        try {
            // Mesma contagem do SearchSaveModal: soma o `total` de cada grupo de
            // filtros selecionados.
            const selected = self.totalSelectedFilters || {};
            let totalSelected = 0;
            Object.keys(selected).forEach(key => {
                const group = selected[key];
                if (group && typeof group === 'object' && 'total' in group) {
                    totalSelected += Number(group.total) || 0;
                }
            });
            const summary = self.summary || {};
            const graphics = self.advancedGraphics || {};
            const history = {
                name: name.trim(),
                totalResults: Number(summary.totalResult) || 0,
                totalEmployees: Number(graphics.totalDecisionMakers) || 0,
                searchId,
                selected_filters: totalSelected,
            };
            await self.searchActions.createSearchHistory(history);
            reply(true);
        }
        catch (e) {
            console.log('[CompanyDetailIframeModal] saveCurrentSearch falhou', e);
            reply(false, 'Não foi possível salvar a busca.');
        }
    }
    close() {
        this.$emit('close');
    }
    clearRetryTimers() {
        this.retryTimers.forEach(t => clearTimeout(t));
        this.retryTimers = [];
    }
    mounted() {
        window.addEventListener('message', this.handleMessage);
    }
    beforeDestroy() {
        this.clearRetryTimers();
        window.removeEventListener('message', this.handleMessage);
    }
};
__decorate([
    PropSync('open', { default: false })
], CompanyDetailIframeModal.prototype, "showModal", void 0);
__decorate([
    Prop({ required: true })
], CompanyDetailIframeModal.prototype, "cnpj", void 0);
__decorate([
    Prop({ default: null })
], CompanyDetailIframeModal.prototype, "infosetId", void 0);
CompanyDetailIframeModal = __decorate([
    Component(connect(({ actions, state }) => ({
        searchActions: actions.search,
        currentSearchId: state.search.currentSearchId,
        summary: state.search.summary,
        advancedGraphics: state.search.advancedGraphics,
        totalSelectedFilters: state.filters.totalSelected,
    }), { name: 'CompanyDetailIframeModal' }))
], CompanyDetailIframeModal);
export default CompanyDetailIframeModal;
